export interface TextTool {
  heading: string
}

const textTool: TextTool = {
  heading: "Format Text",
}

export default textTool
